import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1124 -848)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 6.37048H0V13.6296H20V6.37048Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V3.19477H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 16.8052H0V19.9999H20V16.8052Z",
      fill: "#D80027"
    })
  ]
});
export {
  r as default
};
